import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Box, Spinner, theme } from '@bpba/ui-components';
import { AnalyticsRoot } from './shared/components/AnalyticsRoot';
import { Layout } from './layouts/Layout';
import { ErrorBoundary } from './shared/components/error/ErrorBoundary';
import { ErrorComponent } from './shared/components/error/ErrorComponent';

const Home = lazy(() => import('./features/sucursales/pages/Home').then((m) => ({ default: m.Home })));

const PageLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" width="100%">
    <Spinner size="48px" color={theme.colors.primary[0]} />
  </Box>
);

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ErrorBoundary backupComponent={<ErrorComponent />}>
        <AnalyticsRoot />
        <Routes>
          <Route element={<Layout />}>
            <Route
              path="/"
              element={
                <Suspense fallback={<PageLoader />}>
                  <Home />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
export default App;
